import * as backend from 'backend-helpers/amateurFilms';
import {AMATEUR_FILM_COMMENT_SUCCESS, AMATEUR_FILM_LIKE_SUCCESS} from './amateurFilm';

const GET_AMATEUR_FILM_TAGS_REQUEST = 'GET_AMATEUR_FILM_TAGS_REQUEST';
const GET_AMATEUR_FILM_TAGS_SUCCESS = 'GET_AMATEUR_FILM_TAGS_SUCCESS';
const GET_AMATEUR_FILM_TAGS_FAILURE = 'GET_AMATEUR_FILM_TAGS_FAILURE';

const GET_AMATEUR_FILMS_REQUEST = 'GET_AMATEUR_FILMS_REQUEST';
const GET_AMATEUR_FILMS_SUCCESS = 'GET_AMATEUR_FILMS_SUCCESS';
const GET_AMATEUR_FILMS_FAILURE = 'GET_AMATEUR_FILMS_FAILURE';

const GET_AMATEUR_FILMS_TAGGED_REQUEST = 'GET_AMATEUR_FILMS_TAGGED_REQUEST';
const GET_AMATEUR_FILMS_TAGGED_SUCCESS = 'GET_AMATEUR_FILMS_TAGGED_SUCCESS';
const GET_AMATEUR_FILMS_TAGGED_FAILURE = 'GET_AMATEUR_FILMS_TAGGED_FAILURE';

const initState = {
    isLoading: false,
    list: null,
    totalCount: 0,
    offset: 0,
    tags: [],
    tag: undefined
};

export default function amateurFilms(state = initState, action) {
    if (action.type === GET_AMATEUR_FILM_TAGS_SUCCESS) {
        let {tags} = action.result.data;

        return {
            ...state,
            tags
        }
    }

    if (action.type === GET_AMATEUR_FILMS_REQUEST || action.type === GET_AMATEUR_FILMS_TAGGED_REQUEST) {
        return {
            ...state,
            isLoading: true,
            list: action.infinite ? state.list : [],
        }
    }

    if (action.type === GET_AMATEUR_FILMS_SUCCESS || action.type === GET_AMATEUR_FILMS_TAGGED_SUCCESS) {
        let {list, totalCount, tag} = action.result.data;
        let offset, newList;
        if (action.infinite) {
            newList = Array.prototype.concat(state.list, list);
            offset = action.offset + list.length;
        } else {
            newList = list;
            offset = list.length;
        }

        return {
            ...state,
            isLoading: false,
            list: newList,
            offset,
            totalCount,
            tag: tag
        };
    }

    if (action.type === AMATEUR_FILM_LIKE_SUCCESS) {
        if (state.list) {
            return {
                ...state,
                list: state.list.map((item) => item.id === action.id ? {
                    ...item,
                    is_liked: true,
                    like_count: item.like_count + 1
                } : item)
            }
        }
    }

    if (action.type === AMATEUR_FILM_COMMENT_SUCCESS) {
        if (state.list) {
            return {
                ...state,
                list: state.list.map((item) => item.id === action.id ? {
                    ...item,
                    comment_count: item.comment_count + 1
                } : item)
            }
        }
    }

    return state;
}

export function getAmateurFilmTags(params) {
    return {
        types: [GET_AMATEUR_FILM_TAGS_REQUEST, GET_AMATEUR_FILM_TAGS_SUCCESS, GET_AMATEUR_FILM_TAGS_FAILURE],
        promise: backend.getAmateurFilmTags(params),
    }
}

export function getAmateurFilms({infinite = false, ...params}) {
    return {
        types: [GET_AMATEUR_FILMS_REQUEST, GET_AMATEUR_FILMS_SUCCESS, GET_AMATEUR_FILMS_FAILURE],
        promise: backend.getAmateurFilms(params),
        infinite,
        offset: params.offset
    }
}

export function getAmateurFilmsTagged({infinite = false, ...params}) {
    return {
        types: [GET_AMATEUR_FILMS_TAGGED_REQUEST, GET_AMATEUR_FILMS_TAGGED_SUCCESS, GET_AMATEUR_FILMS_TAGGED_FAILURE],
        promise: backend.getAmateurFilmsTagged(params),
        infinite: infinite,
        offset: params.offset
    }
}


// WEBPACK FOOTER //
// ./src/reducers/amateurFilms.js